import React from 'react';
import Navbar from './shared/Navbar/Navbar';
import Footer from './shared/Footer/Footer';
import Routing from './routes/index';
import Loader from './shared/Loader/Loader';
import { useAppSelector } from './app/hooks';
import PositionedSnackbar from './shared/Alert';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        InputLabelProps: { shrink: true },
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          marginTop: '8px',
          '& .MuiInputLabel-root': {
            fontSize: '14px',
            fontWeight: 500,
            color: '#001B33',
            top: '-8px',
          },
          '& .MuiInputLabel-shrink': {
            top: '-8px',
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#007DB3',
          },
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f8f9fa',
            borderRadius: '6px',
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.23)',
            },
            '&:hover fieldset': {
              borderColor: '#001B33',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#007DB3',
            },
          },
        },
      },
    },
  },
});

const App: React.FC = () => {
  const loading = useAppSelector((store:any) => store.loader.loading);

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Loader isLoading={loading}/>
        <Navbar/>
        <div className="App-content">
        <Routing/>
        </div>
      <Footer/>
        <PositionedSnackbar/>
      </div>
    </ThemeProvider>
  );
};

export default App;
